import FAQS_DATA from "./faqs.json";
export const DOCTOR = {
  name: "Dr. Arun Reddy M",
  short: "Dr. Arun Reddy",
  quals: ["MBBS", "DNB Neurosurgery", "FCVS (Japan)"],
  roles: ["Neurosurgeon", "Endoscopic Spine Surgeon", "Minimally Invasive Spine Surgeon"],
  hospital: "CARE Hospitals",
  location: "Gachibowli, Hyderabad, India",
  phone: "+91 88860 38800",
  phoneRaw: "+918886038800",
  whatsapp: "918886038800",
  photo: "/dr-arun-reddy.png",
  experienceYears: 18,
  mapsUrl: "https://maps.google.com/?q=CARE+Hospitals+Gachibowli+Hyderabad",
  instagram: "https://www.instagram.com/indispinebrainneurocare",
  reviewsUrl: "https://www.google.com/maps/search/Indi+Spine-Brain+Neuro+Care+Madinaguda",
};

export const CLINICS = [
  {
    name: "CARE Hospitals, HITEC City (Gachibowli)",
    area: "Old Mumbai Highway, Near Cyberabad Police Commissionerate, HITEC City, Gachibowli, Hyderabad, Telangana 500032",
    tag: "Day OPD",
    timing: "Mon – Sat, 10:00 AM – 5:00 PM",
    phone: "+91 88860 38800",
    phoneRaw: "+918886038800",
    mapsUrl: "https://maps.google.com/?q=CARE+Hospitals+Gachibowli+Hyderabad",
    mapEmbed: "https://www.google.com/maps?q=CARE+Hospitals+Gachibowli+Hyderabad&output=embed",
  },
  {
    name: "Indi Spine-Brain Neuro Care, Madinaguda",
    area: "H No 7-1/2, Above New Reliance Car Decors, Opposite Bharath Petroleum, Sri Durga Colony, Madeenaguda, Miyapur, Hyderabad, Telangana 500049",
    tag: "Evening Clinic",
    timing: "Mon – Sat, 5:30 PM – 9:00 PM",
    sunday: "Sunday: evenings by appointment",
    phone: "+91 88860 38800",
    phoneRaw: "+918886038800",
    mapsUrl: "https://goo.gl/maps/vbKY9uRBQBqQF8we9",
    mapEmbed: "https://www.google.com/maps?q=Indi+Spine-Brain+Neuro+Care+Madinaguda+Hyderabad&output=embed",
  },
];

export const REELS = [
  { id: "DaUqwHNFOFa", title: "Endoscopic Spine Surgery" },
  { id: "DaOCnRNCU5_", title: "Understanding Your Spine" },
  { id: "DaOB6yEiTsO", title: "Patient Guidance" },
];

export const NAV = [
  { label: "Home", href: "/" },
  { label: "About", href: "/#about" },
  { label: "Conditions", href: "/#conditions" },
  { label: "Treatments", href: "/#procedures" },
  { label: "Endoscopic Surgery", href: "/endoscopic-spine-surgery" },
  { label: "Neurosurgery", href: "/neurosurgery-hyderabad" },
  { label: "Patient Resources", href: "/#education" },
  { label: "Blog", href: "/blog" },
  { label: "Contact", href: "/#contact" },
];

export const STATS = [
  { value: "18+", label: "Years of Experience", sub: "In neuro & spine care" },
  { value: "DNB", label: "Neurosurgery", sub: "Board-certified specialist" },
  { value: "FCVS", label: "International Fellowship", sub: "Japan" },
  { value: "Spine", label: "Specialist Focus", sub: "Endoscopic & minimally invasive" },
  { value: "CARE", label: "Hospital", sub: "Gachibowli, Hyderabad" },
];

export const CONDITIONS = [
  { icon: "Disc3", title: "Slipped Disc", desc: "Herniated disc compressing nerves, causing back or leg pain." },
  { icon: "Activity", title: "Sciatica", desc: "Radiating pain along the sciatic nerve into the leg." },
  { icon: "AlignVerticalSpaceAround", title: "Lumbar Canal Stenosis", desc: "Narrowing of the spinal canal in the lower back." },
  { icon: "Bone", title: "Cervical Disc Disease", desc: "Degeneration or herniation of discs in the neck." },
  { icon: "MoveVertical", title: "Spondylolisthesis", desc: "Slippage of one vertebra over another." },
  { icon: "ScanLine", title: "Spinal Tumours", desc: "Growths within or around the spinal cord and column." },
  { icon: "PersonStanding", title: "Back Pain", desc: "Persistent lower back pain affecting daily life." },
  { icon: "Move3D", title: "Neck Pain", desc: "Chronic cervical pain, stiffness and referred symptoms." },
  { icon: "Footprints", title: "Foot Drop", desc: "Weakness in lifting the foot due to nerve compression." },
];

export const PROCEDURES = [
  {
    title: "Endoscopic Discectomy",
    desc: "Removal of herniated disc material through a small endoscopic portal.",
    benefits: ["Small incision", "Local/regional anaesthesia possible", "Early mobilisation"],
    indications: "Selected disc herniations with nerve compression.",
  },
  {
    title: "Endoscopic Decompression",
    desc: "Relieving pressure on compressed nerves through a keyhole approach.",
    benefits: ["Muscle-sparing", "Reduced blood loss", "Faster recovery"],
    indications: "Lumbar canal stenosis in appropriate candidates.",
  },
  {
    title: "Minimally Invasive Spine Surgery",
    desc: "Tubular, muscle-sparing techniques for a range of spinal conditions.",
    benefits: ["Less tissue disruption", "Shorter hospital stay", "Smaller scars"],
    indications: "Selected degenerative and structural conditions.",
  },
  {
    title: "Microscopic Spine Surgery",
    desc: "High-magnification precision surgery for delicate neural structures.",
    benefits: ["Enhanced visualisation", "Precise decompression", "Established outcomes"],
    indications: "Complex discs and neural compression.",
  },
  {
    title: "Revision Spine Surgery",
    desc: "Careful re-operation for persistent or recurrent spinal problems.",
    benefits: ["Detailed re-evaluation", "Tailored strategy", "Multidisciplinary input"],
    indications: "Failed or recurrent prior spine surgery.",
  },
  {
    title: "Cervical Spine Surgery",
    desc: "Decompression and stabilisation procedures for the neck.",
    benefits: ["Symptom relief", "Preserves function", "Modern implants"],
    indications: "Cervical disc disease & myelopathy.",
  },
  {
    title: "Lumbar Spine Surgery",
    desc: "Comprehensive care for the lower back, from decompression to fusion.",
    benefits: ["Pain relief", "Improved mobility", "Individualised planning"],
    indications: "Lower-back degenerative disorders.",
  },
];

export const JOURNEY = [
  { step: "01", title: "Book Appointment", desc: "Request a consultation online or by phone." },
  { step: "02", title: "Consultation", desc: "Detailed clinical assessment and history." },
  { step: "03", title: "MRI Review", desc: "Secure review of your imaging and reports." },
  { step: "04", title: "Treatment Planning", desc: "Evidence-based, personalised recommendations." },
  { step: "05", title: "Recovery", desc: "Guided rehabilitation and support." },
  { step: "06", title: "Follow-up", desc: "Ongoing monitoring of your progress." },
];

export const EDUCATION = [
  { title: "What is Endoscopic Spine Surgery?", tag: "Explainer", minutes: "4 min", youtube: "mAjLA4equKc" },
  { title: "Understanding Sciatica", tag: "Condition", minutes: "5 min", youtube: "NmOrxvk96-U" },
  { title: "Slipped Disc Explained", tag: "Condition", minutes: "4 min", youtube: "j2XgBBeW4Hw" },
  { title: "Recovery After Spine Surgery", tag: "Recovery", minutes: "6 min", youtube: "cgEyU7GU9Po" },
  { title: "Frequently Asked Questions", tag: "FAQ", minutes: "8 min", href: "#faq" },
];

export const TESTIMONIALS = [
  {
    name: "Santosh Ravi Kishore Maheshkar",
    meta: "Local Guide · 55 reviews",
    rating: 5,
    time: "2 months ago",
    text: "I recently underwent a three-level cervical disc replacement (C3 to C6) about 20 days ago, and I feel truly fortunate to have been treated by Dr. Arun Reddy. Before making a decision, I consulted multiple neurosurgeons across the city. I was extremely anxious and honestly quite scared about undergoing such a complex spine surgery. Nothing gave me complete confidence until I met Dr. Arun Reddy, whom I visited based on a friend's recommendation. What first impressed me was his practice in Japan, a country known for its exceptionally high and disciplined medical standards. But what truly set him apart was the way he explained my condition and treatment options. He recommended artificial disc replacement — a solution that no other doctor had explained to me. A three-level cervical disc replacement is not a simple procedure; it requires high precision, deep expertise, and great judgment. After speaking with Dr. Arun Reddy, I felt a level of trust and confidence that I hadn't experienced anywhere else. Today, just 20 days after surgery, I can confidently say that choosing him was the best decision I made. Even after the surgery and discharge, his care and responsibility never stopped. I sincerely thank him from the bottom of my heart for giving me a better quality of life and the confidence to move forward without fear.",
  },
  {
    name: "Masrath Ali Khan",
    meta: "Local Guide · 103 reviews",
    rating: 5,
    time: "2 months ago",
    text: "We can't thank Dr. Arun Reddy M enough. My wife recently underwent spine surgery under his care, and the results have been life-changing. His precision and expertise gave us so much confidence throughout the process. If you're looking for a surgeon you can truly trust, we highly recommend him.",
  },
];

export const FAQS = FAQS_DATA;
